<template>
  <div ref="lavContainer" :style="style"></div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      required: true
    },
    height: { type: Number },
    width: { type: Number },
    loop: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      style: {
        width: this.width ? `${this.width}px` : '100%',
        height: this.height ? `${this.height}px` : '100%',
        overflow: 'hidden',
        margin: '0 auto'
      }
    };
  },
  async mounted() {
    const lottie = await import('lottie-web');
    this.anim = lottie.loadAnimation({
      container: this.$refs.lavContainer,
      renderer: 'svg',
      loop: this.loop,
      autoplay: false,
      animationData: this.options.animationData,
      rendererSettings: this.options.rendererSettings
    });
    if (this.loop) {
      this.anim.play();
    } else {
      window.addEventListener('scroll', this.startAnimation, false);
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.startAnimation);
    if (this.anim) this.anim.stop();
  },
  methods: {
    startAnimation() {
      const previewImage = this.$refs.lavContainer;
      if (previewImage?.getBoundingClientRect().top + window.innerHeight / 2 < window.innerHeight) {
        this.anim.play();
        window.removeEventListener('scroll', this.startAnimation);
      }
    }
  }
};
</script>
